import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Modal, Drawer, notification } from "antd";
import { 
  Wrapper, 
  
  StatusIcon,
  StatusTitle,
  StatusDescription,
  FailureButtonsWrapper,
   
  MpesaSpinningLogoWrapper
} from "./styles";
import { StyledTitle, StyledParagraph } from "../../components/CustomAntdComponents/Typography";
import bookingFailedIcon from "../../assets/images/bookingfailed.svg";
import bookingPendingIcon from "../../assets/images/bookingPending.svg";
import { useFlightSearchStore } from "../../store/flightSearch/flightSearchStore";
import { useBookingStore } from "../../store/booking/bookingStore";
import { useAuthStore } from "../../store/auth/authStore";
import PaymentHeaderNavigation from "../../components/HeaderNavigation/Payment";
import useIsMobile from "../../hooks/useIsMobile";
import FlightReceipt from "../../components/ReceiptCard/FlightReceipt";
import RoadReceipt from "../../components/ReceiptCard/RoadReceipt";
import WaterReceipt from "../../components/ReceiptCard/WaterReceipt";
import TrainReceipt from "../../components/ReceiptCard/TrainReceipt";
import { StyledButton } from "../../components/CustomAntdComponents/StyledButton";
import BookingFeedback from "../../components/BookingFeedback";
import FeedbackForm, { FeedbackFormData } from "../../components/FeedbackForm";
import { submitFeedbackToGoogleSheet } from "../../utils/feedback";
import { useRoadSearchStore } from "../../store/roadSearch/roadSearchStore";
import FlightPayment from "./FlightPayment";
import AnimatedTimer from "../../components/PaymentComponents/AnimatedTimer";
import RoadPayment from "./RoadPayment";
import Done from "../../components/FeedbackForm/Done";
import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";
import AlertWarningIcon from "../../assets/images/alert-warning-icon.svg";
// import B2CPayment from "./B2CPayment";
import SaveDetailsModal from "../../components/BookingSuccess/SaveDetailsModal";
import { encryptedPostAPI, getAPI, postAPI } from "../../utils/api";
import { 

  INITIATE_PAYMENT_URL,
  PaymentGateway,
  PAYMENT_GATEWAY_MAPPING,
  CONFIRM_PAYMENT_URL,
  PAYMENT_HUB_URL,
  TRIPS_PAYMENT_CHANNEL
} from "../../utils/constants";
import { extractApiErrorMessage } from "../../utils/helpers";
import { PaymentHandlerRegistry } from "./paymentHandlers";

import {
  PriceInformationMain,
  CloseIconContainer,
  PriceInformationIconContainer,
  PriceInformationIconImage,
  PriceInformationTitle,
  PriceInformationMessage,
} from "../../components/SearchPriceNotification/styles";
import { MobileDrawerContentDisclaimer } from "../../components/HeaderNavigation/Flight/styles";
import { useRedirectHome } from "../../hooks/useRedirectHome";
import { isEmbedded } from "../../utils/navigation";
 
const loadPaystackScript = (): Promise<boolean> => {
  return new Promise((resolve) => {
    if ((window as any).PaystackPop) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://js.paystack.co/v2/inline.js";
    script.async = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

function Payment() {
  const { isMobile } = useIsMobile();
  const [openBooking, setOpenBooking] = useState<boolean>(false);
  const [openFeedback, setOpenFeedback] = useState<boolean>(false);
  const [openFeedbackForm, setOpenFeedbackForm] = useState<boolean>(false);
  const [openFeedbackDone, setOpenFeedbackDone] = useState<boolean>(false);
  const [openSaveDetails, setOpenSaveDetails] = useState<boolean>(false);
  const [reaction, setReaction] = useState("");
  const [feedbackFormData, setFeedbackFormData] = useState<FeedbackFormData>({
    positiveFeedback: ['Prices were fair'],
    improvementAreas: ['Loading time'],
    comment: '',
  });
  const [gobackNotification, setGobackNotification] = useState<boolean>(false);
  const navigate = useNavigate();
  const redirectHome = useRedirectHome();

  const drawerContainerRef = useRef(null);
  const { tripType } = useParams();
  const { resetFormData } = useFlightSearchStore();
  const { isLoggedIn } = useAuthStore();
  const { resetFormData: resetRoadSearchData } = useRoadSearchStore();

  const { bookingPayload, resetBooking, encryptedBookingData, setReservation, confirmData } = useBookingStore();
  const { formData: flightFormData } = useFlightSearchStore();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [bookingError, setBookingError] = useState("");
  const [isPaymentFailed, setIsPaymentFailed] = useState<boolean>(false);
  const [isPaymentPending, setIsPaymentPending] = useState<boolean>(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState<string>("");

  const [lastVerifyPayload, setLastVerifyPayload] = useState<any>(null);
  const [confirmPaymentLoaderModal, setConfirmPaymentLoaderModal] = useState<boolean>(false);
  const [confirmSecondsLeft, setConfirmSecondsLeft] = useState<number>(60);
  const [confirmPaymentLoading, setConfirmPaymentLoading] = useState<boolean>(false);
  const [confirmPayload, setConfirmPayload] = useState<any>(null);
  const confirmTimerRef = useRef<any>(null);
  const hubConnectionRef = useRef<any>(null);
  const [paymentMethod, setPaymentMethod] = useState<string | null>(null);
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [paymentMethodsLoading, setPaymentMethodsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchMethods = async () => {
      const auth = JSON.parse(localStorage.getItem('trips_auth') || '{}');
      if (auth?.ExtraData?.PaymentChannel === TRIPS_PAYMENT_CHANNEL) {
        setPaymentMethodsLoading(true);
        try {
          const res = await getAPI("/Payment/get-merchant-gateway");
          if (res.status === 200 && res.data?.IsSuccessful && Array.isArray(res.data.Data)) {
            setPaymentMethods(res.data.Data);
          }
        } catch (err) {
          console.error("Error fetching merchant gateways:", err);
        } finally {
          setPaymentMethodsLoading(false);
        }
      }
    };
    fetchMethods();
  }, []);

  const formatTime = (secs: number) => {
    const m = Math.floor(secs / 60).toString().padStart(2, '0');
    const s = (secs % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  useEffect(() => {
    return () => {
      if (confirmTimerRef.current) {
        clearInterval(confirmTimerRef.current);
      }
      if (hubConnectionRef.current) {
        hubConnectionRef.current.stop();
      }
    };
  }, []);

  function startConfirmTimer(verifyPayload: any) {
    setConfirmPayload(verifyPayload);
    setLastVerifyPayload(verifyPayload);
    setConfirmPaymentLoaderModal(true);
    setConfirmSecondsLeft(600);
    setConfirmPaymentLoading(false);

    if (confirmTimerRef.current) {
      clearInterval(confirmTimerRef.current);
    }
    let seconds = 600;
    confirmTimerRef.current = setInterval(() => {
      seconds -= 1;
      setConfirmSecondsLeft(seconds);
      if (seconds <= 0) {
        if (confirmTimerRef.current) {
          clearInterval(confirmTimerRef.current);
        }
        confirmTimerRef.current = null;
      }
    }, 1000);
  }

  async function verifyConfirmPayment(payloadToVerify?: any) {
    const activePayload = payloadToVerify || confirmPayload;
    if (!activePayload) return;

    setConfirmPaymentLoading(true);
    setPaymentLoading(true);

    try {
      const verifyRes = await postAPI(CONFIRM_PAYMENT_URL, activePayload);
      setConfirmPaymentLoading(false);
      setPaymentLoading(false);

      if (verifyRes.status === 200 && verifyRes.data?.IsSuccessful) {
        const verifyData = verifyRes.data.Data;
        const paymentStatus = verifyData?.PaymentStatus;
        
        if (paymentStatus === 1 || paymentStatus === 2) {
          setConfirmPaymentLoaderModal(false);
          handlePaymentStatus(paymentStatus);
        } else if (paymentStatus === 0) {
          // Reset timer for another 60 seconds
          startConfirmTimer(activePayload);
        } else {
          setConfirmPaymentLoaderModal(false);
          setIsPaymentFailed(true);
          setPaymentErrorMessage(verifyRes.data?.Message || "Sorry, we encountered an issue while trying to process your payment. Kindly ensure your account is properly funded and try again");
        }
      } else {
        setConfirmPaymentLoaderModal(false);
        setIsPaymentFailed(true);
        setPaymentErrorMessage("Sorry, we encountered an issue while trying to process your payment. Kindly ensure your account is properly funded and try again");
      }
    } catch (err) {
      setConfirmPaymentLoading(false);
      setPaymentLoading(false);
      setConfirmPaymentLoaderModal(false);
      setIsPaymentFailed(true);
      setPaymentErrorMessage("Sorry, we encountered an issue while trying to process your payment. Kindly ensure your account is properly funded and try again");
    }
  }

  const handleMadePayment = () => {
    if (confirmTimerRef.current) {
      clearInterval(confirmTimerRef.current);
      confirmTimerRef.current = null;
    }
    verifyConfirmPayment();
  };

  const handleTryAgain = async () => {
    setIsPaymentFailed(false);
    setIsPaymentPending(false);
    setPaymentErrorMessage("");

    if (lastVerifyPayload) {
      setPaymentLoading(true);
      try {
        const verifyRes = await postAPI(CONFIRM_PAYMENT_URL, lastVerifyPayload);
        if (verifyRes.status === 200 && verifyRes.data?.IsSuccessful) {
          const verifyData = verifyRes.data.Data;
          const paymentStatus = verifyData?.PaymentStatus;
          handlePaymentStatus(paymentStatus);
        } else {
          setPaymentLoading(false);
          setIsPaymentFailed(true);
          setPaymentErrorMessage("Sorry, we encountered an issue while trying to verify your payment. Kindly ensure your account is properly funded and try again");
        }
      } catch (err) {
        setPaymentLoading(false);
        setIsPaymentFailed(true);
        setPaymentErrorMessage("Sorry, we encountered an issue while trying to verify your payment. Kindly ensure your account is properly funded and try again");
      }
    } else {
      proceedPayment(paymentMethod);
    }
  };

  const handleGoBack = (showWarning = false) => {
    setIsPaymentFailed(false);
    setIsPaymentPending(false);
    setPaymentErrorMessage("");
    if (hubConnectionRef.current) {
      hubConnectionRef.current.stop();
      hubConnectionRef.current = null;
    }
    if (showWarning) {
      customNavigateHandler();
    } else {
      redirectToSearch();
    }
  };

  const handlePaymentStatus = (status: number) => {
    setPaymentLoading(false);
    setConfirmPaymentLoaderModal(false);
    if (hubConnectionRef.current) {
      hubConnectionRef.current.stop();
      hubConnectionRef.current = null;
    }
    
    if (status === 1 || status === 2) {
      setBookingSuccess(true);
      setShowPaymentModal(false);
      if (isMobile) {
        navigate(`/payment-receipt/${tripType}`);
      } else {
        setOpenBooking(true);
      }
    } else if (status === 0) {
      setIsPaymentPending(true);
    } else {
      let statusName = "Pending";
      if (status === 3) statusName = "Failed";
      if (status === 4) statusName = "Canceled";
      
      if (status === 3) {
        setIsPaymentFailed(true);
        setPaymentErrorMessage("Sorry, we encountered an issue while trying to process your payment. Kindly ensure your account is properly funded and try again");
      } else {
        notification.error({
          message: "Payment Status Alert",
          description: `Payment was not successful. Status: ${statusName}`,
          placement: "topRight"
        });
      }
    }
  };

   
  const proceedPayment = async (method: any, customPhone?: string, publicKey?: string) => {
    let methodKey = "card";
    let gatewayId = PaymentGateway.CARD;
    if (method) {
      if (typeof method === "string") {
        methodKey = method;
        gatewayId = PAYMENT_GATEWAY_MAPPING[method] || PaymentGateway.CARD;
      } else {
        gatewayId = method.GatewayId;
        if (gatewayId === PaymentGateway.WALLET) {
          methodKey = "wallet";
        } else if (gatewayId === PaymentGateway.MPESA) {
          methodKey = "mpesa";
        } else {
          methodKey = "card";
        }
      }
    }
    setPaymentMethod(methodKey);
    const auth: UserAuth = JSON.parse(localStorage.getItem("trips_auth") || "{}");
    
     if (auth.ExtraData?.PaymentChannel === TRIPS_PAYMENT_CHANNEL) {
      setPaymentLoading(true);
      setBookingError("");
      setIsPaymentFailed(false);
      setIsPaymentPending(false);
      setPaymentErrorMessage("");
      setLastVerifyPayload(null);
      setConfirmPayload(null);

      try {
        const flightBookingContact = useFlightSearchStore.getState().bookingContact;
        const roadBookingContact = useRoadSearchStore.getState().bookingContact;
         
        const bookingContact = tripType === "flight" ? flightBookingContact : roadBookingContact;
        
        const email = confirmData?.[0]?.PassengerDetails?.BillingAddress?.ContactEmail || bookingContact?.email || useAuthStore.getState().b2CUser?.Email || "";
        const sessionId = tripType === "road" 
          ? (useRoadSearchStore.getState().tripsSessionId || "")
          : (confirmData?.[0]?.PassengerDetails?.SessionId || "");
        const phoneNumber = methodKey === "card"
          ? (confirmData?.[0]?.PassengerDetails?.BillingAddress?.ContactMobileNo || bookingContact?.phone || "")
          : (customPhone || confirmData?.[0]?.PassengerDetails?.BillingAddress?.ContactMobileNo || bookingContact?.phone || "");

        const cleanPhone = phoneNumber.replace(/[\s\+]/g, "");
        if (methodKey === "mpesa" && (!cleanPhone || cleanPhone.length <= 3)) {
          setPaymentLoading(false);
          notification.error({
            message: "Phone Number Required",
            description: "Please ensure your contact details contain a valid phone number.",
            placement: "topRight",
          });
          return;
        }

        const initiatePayload = {
          sessionId: sessionId || "",
          // pnrNumber: confirmData?.[0]?.ConfirmationCode || "",
          email: email,
          gatewayId: gatewayId,
           
          phoneNumber: phoneNumber.replace("+", "")
        };

        // Establish SignalR connection and subscribe via SessionId BEFORE calling the initiation API
        let activeConn: any = null;
        if (methodKey === "mpesa") {
          try {
            if (hubConnectionRef.current) {
              try {
                await hubConnectionRef.current.stop();
              } catch (e) {}
              hubConnectionRef.current = null;
            }

            const signalR = await import("@microsoft/signalr");
            const conn = new signalR.HubConnectionBuilder()
              .withUrl(PAYMENT_HUB_URL)
              .withAutomaticReconnect()
              .build();

            conn.onclose((error) => {
              console.log("SignalR Connection Closed:", error);
            });
            conn.onreconnecting((error) => {
              console.log("SignalR Connection Reconnecting:", error);
            });
            conn.onreconnected((connectionId) => {
              console.log("SignalR Connection Reconnected. New ConnectionId:", connectionId);
            });

            conn.on("PaymentStatusUpdated", (data: any) => {
              console.log("PaymentStatusUpdated message received [360]:", data);
              const status = data?.paymentStatus;
              if (status !== undefined && status !== 0) {
                if (confirmTimerRef.current) {
                  clearInterval(confirmTimerRef.current);
                  confirmTimerRef.current = null;
                }
                handlePaymentStatus(status);
              }
            });

            conn.on("Subscribed", (group: string) => {
              console.log("Successfully subscribed to:", group);
            });

            await conn.start();
            console.log("Connected to payment hub! Connection ID:", conn.connectionId);
            hubConnectionRef.current = conn;
            activeConn = conn;

            if (sessionId) {
              await conn.invoke("SubscribeToPayment", sessionId);
              // console.log("Successfully sent SubscribeToPayment invocation for SessionId:", sessionId);
            }
          } catch (err) {
            console.error("SignalR Connection/Subscription Error before initiation:", err);
          }
        }

        const response = await postAPI(INITIATE_PAYMENT_URL, initiatePayload);

        // IsSuccessful
        if (response.status === 200 && response.data?.IsSuccessful) {
          const paymentData = response.data.Data;
           

          const handler = PaymentHandlerRegistry[methodKey];
          if (handler) {
            await handler({
              paymentData,
              initiatePayload,
              handlePaymentStatus,
              setPaymentLoading,
              setIsPaymentFailed,
              setPaymentErrorMessage,
              loadPaystackScript,
              setLastVerifyPayload,
              publicKey,
              onMpesaInitiated: async (pData, initPayload) => {
                const reference = pData?.TransactionReference || pData?.Reference || pData?.CheckoutRequestID || "";
                const verifyPayload = {
                  ...initPayload,
                  reference,
                };
                startConfirmTimer(verifyPayload);

                // Fallback connection check
                if (!hubConnectionRef.current && activeConn === null) {
                  try {
                    const signalR = await import("@microsoft/signalr");
                    const conn = new signalR.HubConnectionBuilder()
                      .withUrl(PAYMENT_HUB_URL)
                      .withAutomaticReconnect()
                      .build();

                    conn.on("PaymentStatusUpdated", (data: any) => {
                      console.log("PaymentStatusUpdated message received (fallback):", data);
                      const status = data?.paymentStatus;
                      if (status !== undefined && status !== 0) {
                        if (confirmTimerRef.current) {
                          clearInterval(confirmTimerRef.current);
                          confirmTimerRef.current = null;
                        }
                        handlePaymentStatus(status);
                      }
                    });

                    await conn.start();
                    console.log("Connected to payment hub (fallback)!");
                    hubConnectionRef.current = conn;

                    if (sessionId) {
                      await conn.invoke("SubscribeToPayment", sessionId);
                      console.log("Subscribed (fallback) to SessionId:", sessionId);
                    }
                  } catch (err) {
                    console.error("SignalR Fallback Error:", err);
                  }
                }
              },
              onVerificationStarted: (verifyPayload) => {
                setConfirmPaymentLoaderModal(true);
              },
              onVerificationEnded: () => {
                setConfirmPaymentLoaderModal(false);
              }
            });
          } else {
            setPaymentLoading(false);
            notification.error({
              message: "Unsupported Payment Method",
              description: `Payment method ${methodKey} is not supported yet.`,
              placement: "topRight",
            });
          }
        } else {
          setPaymentLoading(false);
          const errorMsg = extractApiErrorMessage(response.data, "Initiation failed.");
          
          notification.error({
            message: "Payment Initiation Failed",
            description: errorMsg,
            placement: "topRight"
          });
        }
      } catch (err: any) {
        console.error("Payment initiation error:", err);
        setPaymentLoading(false);
        const errorMsg = extractApiErrorMessage(err.response?.data, "An unexpected error occurred while initiating payment.");
        notification.error({
          message: "Payment Error",
          description: errorMsg,
          placement: "topRight",
        });
      }
    } else {
      postMessage(encryptedBookingData);
    }
  };

  const renderTripReceipt = () => {
    switch (tripType) {
      case "flight":
        return <FlightReceipt />;
      case "road":
        return <RoadReceipt />;
      case "water":
        return <WaterReceipt />;
      case "rail":
        return <TrainReceipt />;
      default:
        return null;
    }
  };

  const redirectToSearch = () => {
    if (isEmbedded()) {
      redirectHome();
      return;
    }

    resetBooking();

    if (tripType === "flight") {
      resetFormData();
    }

    if (tripType === "road") {
      resetRoadSearchData();
    }

    navigate(`/search/${tripType}`);
  };

  const customNavigateHandler = () => {
    //  open modal to confirm if user wants to leave payment page
    if (isMobile) {
      setGobackNotification(true);
    } else {
      setOpenBooking(false);
      setOpenFeedback(false);
      setOpenFeedbackForm(false);
      setOpenFeedbackDone(false);
      setGobackNotification(true);
    }
  };

  const handleFeedbackExit = () => {
    setOpenFeedback(false);
    setOpenFeedbackForm(false);
    setOpenFeedbackDone(false);
    if (!isLoggedIn) {
      setOpenSaveDetails(true);
    } else {
      redirectHome();
    }
  };

  const BookingFooter = (
    <StyledButton
      mode="primary"
      block
      onClick={() => {
        setOpenBooking(false);
        setOpenFeedback(true);
      }}
    >
      Done
    </StyledButton>
  );

  const FeedbackFooter = (
    <StyledButton mode="default" block onClick={handleFeedbackExit}>
      Not now
    </StyledButton>
  );

  const handleFeedbackSubmit = () => {
    const flightBookingContact = useFlightSearchStore.getState().bookingContact;
    const roadBookingContact = useRoadSearchStore.getState().bookingContact;
    const bookingContact = tripType === "flight" ? flightBookingContact : roadBookingContact;
    const userEmail = bookingContact?.email || useAuthStore.getState().b2CUser?.Email || "";
    const bookingStoreState = useBookingStore.getState();
    const bookingReference = 
      (bookingStoreState?.flightReservation as any)?.BookingReferenceId ||
      (bookingStoreState?.roadReservation as any)?.BookingReferenceId ||
      (bookingStoreState?.confirmData as any)?.[0]?.BookingReferenceId ||
      (bookingStoreState?.bookingPayload as any)?.BookingReference ||
      "";

    submitFeedbackToGoogleSheet({
      rating: reaction,
      positiveFeedback: feedbackFormData.positiveFeedback,
      improvementAreas: feedbackFormData.improvementAreas,
      comment: feedbackFormData.comment,
      bookingReference,
      userEmail,
    });

    setOpenFeedbackForm(false);
    setOpenFeedbackDone(true);
  };

  const FeedbackFormFooter = (
    <StyledButton
      mode="primary"
      block
      onClick={handleFeedbackSubmit}
    >
      Submit feedback
    </StyledButton>
  );

  const FeedbackDoneFooter = (
    <StyledButton mode="primary" block onClick={handleFeedbackExit}>
      Done
    </StyledButton>
  );

  const renderTripPayment = () => {
    switch (tripType) {
      case "flight":
        return (
          <FlightPayment
            handlePayment={proceedPayment}
            loading={paymentLoading}
            bookingSuccess={bookingSuccess}
            paymentMethods={paymentMethods}
            paymentMethodsLoading={paymentMethodsLoading}
          />
        );
      case "road":
        return (
          <RoadPayment
            handlePayment={proceedPayment}
            loading={paymentLoading}
            bookingSuccess={bookingSuccess}
            paymentMethods={paymentMethods}
            paymentMethodsLoading={paymentMethodsLoading}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Wrapper ref={drawerContainerRef} $tripType={tripType}>
      <Row>
        <Col span={24}>
          <PaymentHeaderNavigation navigateHandler={customNavigateHandler} />
        </Col>
      </Row>

      {/* this modal shd also show when confirm payment is loading for card */}
      <Modal
        centered
        open={confirmPaymentLoaderModal}
        footer={null}
        closable={false}
        className="custom-rounded-modal-32"
        width={600}
        maskClosable={false}
        getContainer={drawerContainerRef.current as HTMLElement || document.body}
      >
        <div style={{ textAlign: "center", padding: "24px 16px" }}>
          <MpesaSpinningLogoWrapper>
            <AnimatedTimer size={130} />
          </MpesaSpinningLogoWrapper>
          
          <div style={{ marginTop: 24, marginBottom: 12 }}>
            <StyledTitle level={2} align="center" >
              Waiting for your payment confirmation
            </StyledTitle>
          </div>
          
          <div style={{ marginBottom: 20 }}>
            <StyledParagraph align="center" style={{ color: "#666" }} size="medium">
              Do not close or refresh this screen
            </StyledParagraph>
          </div>
          
          <div style={{ marginBottom: 24 }}>
            {paymentMethod === "mpesa" ? (
              <>
                <StyledParagraph align="center" style={{ color: "#555", marginBottom: "12px" }} size="normal">
                  Please click the button below to verify payment if you have completed the transaction.
                </StyledParagraph>
                {confirmSecondsLeft > 0 && (
                  <StyledParagraph align="center" style={{ fontWeight: 600, color: "#EC9832" }}>
                    Checking status in {formatTime(confirmSecondsLeft)}...
                  </StyledParagraph>
                )}
              </>
            ) : (
              <StyledParagraph align="center" style={{ fontWeight: 600, color: "#EC9832" }}>
                Verifying your payment...
              </StyledParagraph>
            )}
          </div>
          
          {paymentMethod === "mpesa" && (
            <StyledButton 
              mode="primary" 
              block 
              onClick={handleMadePayment}
              loading={confirmPaymentLoading}
              style={{ height: "46px" }}
            >
              I have made payment
            </StyledButton>
          )}
        </div>
      </Modal>

      {renderTripPayment()}

      <Modal
        centered
        open={isPaymentPending}
        footer={null}
        closable={true}
        onCancel={() => handleGoBack(true)}
        width={500}
        className="custom-rounded-modal"
        getContainer={drawerContainerRef.current as HTMLElement || document.body}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "20px 10px" }}>
          <StatusIcon src={bookingPendingIcon} alt="Payment pending" style={{ marginBottom: 24 }} />
          <StatusTitle style={{ marginBottom: 12 }}>Payment is processing</StatusTitle>
          <StatusDescription style={{ marginBottom: 32 }}>
            We are still trying to confirm your payment. Kindly hold on for a few minutes
          </StatusDescription>
          <FailureButtonsWrapper>
            <StyledButton
              style={{ width: "100%", height: "48px", borderRadius: "100px" }}
              mode="primary"
              onClick={handleTryAgain}
            >
              Retry
            </StyledButton>
            <StyledButton
              style={{ width: "100%", height: "48px", borderRadius: "100px" }}
              mode="default"
              onClick={() => handleGoBack(true)}
            >
              Done
            </StyledButton>
          </FailureButtonsWrapper>
        </div>
      </Modal>

      <Modal
        centered
        open={isPaymentFailed}
        footer={null}
        closable={false}
        width={500}
        className="custom-rounded-modal"
        getContainer={drawerContainerRef.current as HTMLElement || document.body}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "20px 10px" }}>
          <StatusIcon src={bookingFailedIcon} alt="Booking failed" style={{ marginBottom: 24 }} />
          <StatusTitle style={{ marginBottom: 12 }}>Payment failed</StatusTitle>
          <StatusDescription style={{ marginBottom: 32 }}>
            {paymentErrorMessage || "Sorry, we encountered an issue while trying to process your payment. Kindly ensure your account is properly funded and try again"}
          </StatusDescription>
          <FailureButtonsWrapper>
            <StyledButton
              style={{ width: "100%", height: "48px", borderRadius: "100px" }}
              mode="primary"
              onClick={() => setIsPaymentFailed(false)}
            >
              Try again
            </StyledButton>
            <StyledButton
              style={{ width: "100%", height: "48px", borderRadius: "100px" }}
              mode="default"
              onClick={() => handleGoBack(true)}
            >
              Go back
            </StyledButton>
          </FailureButtonsWrapper>
        </div>
      </Modal>

      {!isMobile && (
        <>
          <Modal
            centered
            open={openBooking}
            footer={BookingFooter}
            onCancel={() => {
              setOpenBooking(false);
              if (isEmbedded()) {
                redirectHome();
              } else {
                redirectToSearch();
              }
            }}
            width={650}
            getContainer={drawerContainerRef.current as HTMLElement}
          >
            {openBooking && renderTripReceipt()}
          </Modal>

          <SaveDetailsModal 
            open={openSaveDetails} 
            onClose={() => {
              setOpenSaveDetails(false);
               redirectHome();
            }} 
          />

          <Modal
            centered
            open={openFeedback}
            footer={FeedbackFooter}
            onCancel={handleFeedbackExit}
            width={650}
            getContainer={drawerContainerRef.current as HTMLElement}
          >
            <BookingFeedback
              openFeedbackForm={(reaction: string) => {
                setReaction(reaction);
                setOpenFeedback(false);
                setOpenFeedbackForm(true);
              }}
              hideAction
            />
          </Modal>
          <Modal
            centered
            open={openFeedbackForm}
            footer={FeedbackFormFooter}
            onCancel={handleFeedbackExit}
            width={650}
            getContainer={drawerContainerRef.current as HTMLElement}
          >
            <FeedbackForm 
              reaction={reaction} 
              feedbackData={feedbackFormData}
              onChange={setFeedbackFormData}
            />
          </Modal>
          <Modal
            centered
            open={openFeedbackDone}
            footer={FeedbackDoneFooter}
            onCancel={handleFeedbackExit}
            width={650}
            getContainer={drawerContainerRef.current as HTMLElement}
          >
            <Done />
          </Modal>
          <Modal
            centered
            open={gobackNotification}
            closable={false}
            footer={null}
            onCancel={() => setGobackNotification(false)}
            width={500}
            getContainer={drawerContainerRef.current as HTMLElement}
            className="custom-rounded-modal"
          >
            <PriceInformationMain>
              <PriceInformationIconContainer>
                <PriceInformationIconImage src={AlertWarningIcon} alt="alert" />
              </PriceInformationIconContainer>

              <PriceInformationTitle>Want to go back?</PriceInformationTitle>
              <PriceInformationMessage>
                Your progress will be lost and you will be taken to the {tripType} search page.
              </PriceInformationMessage>

              <StyledButton
                style={{ width: "100%", marginBottom: "10px" }}
                mode="primary"
                onClick={() => setGobackNotification(false)}
              >
                Continue to payment
              </StyledButton>
              <StyledButton style={{ width: "100%" }} mode="outline" onClick={redirectToSearch}>
                Go back search
              </StyledButton>
            </PriceInformationMain>
          </Modal>
        </>
      )}

      {isMobile && <Drawer
        open={gobackNotification}
        onClose={() => setGobackNotification(false)}
        // headerStyle={{ display: "none" }}
        placement="bottom"
        height="35%"
        getContainer={document.getElementById("app-container") as HTMLElement}
        closable={false}
      >
        <MobileDrawerContentDisclaimer>
          <PriceInformationMain>
            {/* close button */}
            <CloseIconContainer onClick={() => setGobackNotification(false)}>
              <CloseIcon />
            </CloseIconContainer>

            <PriceInformationIconContainer>
              <PriceInformationIconImage src={AlertWarningIcon} alt="alert" />
            </PriceInformationIconContainer>

            <PriceInformationTitle>Want to go back?</PriceInformationTitle>
            <PriceInformationMessage>
              Your progress will be lost and you will be taken to the {tripType} search page.
            </PriceInformationMessage>

            <StyledButton
              style={{ width: "100%", marginBottom: "10px" }}
              mode="primary"
              onClick={() => setGobackNotification(false)}
            >
              Continue to payment
            </StyledButton>
            <StyledButton style={{ width: "100%" }} mode="outline" onClick={redirectToSearch}>
              Go back search
            </StyledButton>
          </PriceInformationMain>
        </MobileDrawerContentDisclaimer>
      </Drawer>}

       
    </Wrapper>
  );
}

export default Payment;
